import { useGetCapabilitiesQuery } from '@/modules/services';
import { Roles } from './roles/roles.type';
import { useEffect, useState } from 'react';

export const hasRole = (allowedRoles: Roles[], userRoles: Roles[]): boolean =>
  allowedRoles.some((item) => userRoles.includes(item));

export function useUserHasRole(allowedRoles: Roles[]) {
  const { data: capabilities, isLoading } = useGetCapabilitiesQuery('');
  const [roleHasCapabilities, setRoleHasCapabilities] = useState<
    boolean | undefined
  >();

  useEffect(() => {
    if (isLoading || !capabilities) return;

    if (capabilities) {
      const boolRole = hasRole(allowedRoles, capabilities?.roles);
      setRoleHasCapabilities(boolRole);
    }
  }, [capabilities, isLoading]);

  return roleHasCapabilities;
}
